import { render, staticRenderFns } from "./SentimentsToggle.vue?vue&type=template&id=ce32f284&"
import script from "./SentimentsToggle.vue?vue&type=script&lang=js&"
export * from "./SentimentsToggle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports